export default {
  placeholder: 'None',
};
